import React from "react";
import { PhoneIcon, ArrowSmRightIcon } from "@heroicons/react/outline";
import { ChipIcon, SupportIcon } from "@heroicons/react/solid";
import supportImg from "../assets/support.jpg";

const Support = () => {
  return (
    <div name="support" className="w-full mt-24">
      <div className="w-full h-[700px] bg-gray-900/90 absolute">
        <img
          className="w-full h-full object-cover mix-blend-overlay"
          src={supportImg}
          alt=""
        />
      </div>
      <div className="max-w-[1240px] mx-auto text-white relative">
        <div className="px-4 py-12">
          <h2 className="text-5xl pt-8 font-semibold text-slate-300 uppercase text-center">
            Support
          </h2>
          <h3 className="text-4xl font-bold py-6 text-center">
            Finding the right team
          </h3>
          <p className="py-4 px-14 text-2xl text-slate-300 text-center">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae, modi
            totam? Ex quidem pariatur sint dolorum obcaecati alias, temporibus
            molestias dicta placeat laborum aliquam recusandae commodi, sunt
            architecto amet! Voluptatibus?
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 relative gap-x-9 gap-y-16 px-14 pt-12 sm:pt-20 text-black">
          <div className="bg-white rounded-xl shadow-2xl">
            <div className="p-8">
              <PhoneIcon className="w-14 p-4 bg-indigo-600 text-white rounded-lg mt-[-4rem]" />
              <h3 className="font-bold text-2xl my-6">Sales</h3>
              <p className="text-gray-600 text-xl">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Tempore tenetur eaque natus? Culpa doloribus quis commodi enim
                fugit? Ea, eum.
              </p>
            </div>
            <div className="bg-slate-200 pl-8 py-4">
              <p className="flex items-center text-indigo-700">
                Contact Us <ArrowSmRightIcon className="w-5 ml-2" />
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-2xl">
            <div className="p-8">
              <SupportIcon className="w-14 p-4 bg-indigo-600 text-white rounded-lg mt-[-4rem]" />
              <h3 className="font-bold text-2xl my-6">Technical Support</h3>
              <p className="text-gray-600 text-xl">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Tempore tenetur eaque natus? Culpa doloribus quis commodi enim
                fugit? Ea, eum.
              </p>
            </div>
            <div className="bg-slate-200 pl-8 py-4">
              <p className="flex items-center text-indigo-700">
                Contact Us <ArrowSmRightIcon className="w-5 ml-2" />
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-2xl ">
            <div className="p-8">
              <ChipIcon className="w-14 p-4 bg-indigo-600 text-white rounded-lg mt-[-4rem]" />
              <h3 className="font-bold text-2xl my-6">Media Inquiries</h3>
              <p className="text-gray-600 text-xl">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Tempore tenetur eaque natus? Culpa doloribus quis commodi enim
                fugit? Ea, eum.
              </p>
            </div>
            <div className="bg-slate-200 pl-8 py-4 ">
              <p className="flex items-center text-indigo-700">
                Contact Us <ArrowSmRightIcon className="w-5 ml-2" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
